<template>
    <div :class="{ 'org-select-only': !showResult, 'org-select-inner': true }">
        <div
            v-if="show"
            class="org-select-opt-box"
        >
            <div class="org-select-sub-tit">
                {{ subtitle }}
            </div>
            <v-input
                v-if="showSearch"
                v-model="keywords"
                :placeholder="searchPlaceholder"
                class="org-select-search-input"
                name="keywords"
                kind="search"
                autofocus
                @search="search"
            />

            <big-tree-list
                v-if="useBigTree"
                v-show="!searching"
                ref="bigTree"
                v-bind="$attrs"
                :selected="currentSelected"
                :with-single="single"
                :with-checkbox="withCheckbox"
                :folder-can-select="folderCanSelect"
                :cust-fetch-tree="custFetchTree"
                @change="selectedChange"
            />

            <tree-list
                v-else-if="departCanSelect && !withCheckbox"
                v-show="!searching"
                :single="single"
                :depart-can-select="departCanSelect"
                :his-selected="hisSelected"
                :selected="currentSelected"
                @change="selectedChange"
            />
            <tree-checkbox-list
                v-else
                v-show="!searching"
                ref="checkTree"
                :single="single"
                :folder-can-select="folderCanSelect"
                :his-selected="hisSelected"
                :selected="currentSelected"
                :cust-fetch-tree="custFetchTree"
                :maps="maps"
                v-bind="$attrs"
                @change="selectedChange"
            />
            <search-list
                v-show="searching"
                ref="search"
                v-model="keywords"
                :selected="currentSelected"
                :his-selected="hisSelected"
                :single="single"
                :with-checkbox="withCheckbox"
                :cust-fetch-search="custFetchSearch"
                :cust-search-list="custSearchList"
                @change="selectedChange"
            />
        </div>

        <div
            v-if="showResult"
            class="org-select-split-arrow"
        >
            <v-icon name="arrow-right" />
        </div>
        <div
            v-if="showResult"
            class="org-select-res-box"
        >
            <div class="org-select-sub-tit">
                {{ titleSelectedAndNum }}
            </div>
            <selected-list
                :selected="currentSelected"
                v-bind="$attrs"
                @change="selectedChange"
            />
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import SearchList from './search-list';
import TreeList from './tree-list';
import TreeCheckboxList from './tree-checkbox-list';
import BigTreeList from './big-tree-list';
import SelectedList from './selected-list';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

/**
 * 该组件，在部门下直接选择的数据和通过搜索得到的数据输出的数据格式不同，导致使用的时候因为用法问题产生了一定的问题，将会在分组沉淀需求上线后修复这个问题，并提供一个数据输出文档
 * 现在临时在业务组件中修复这个问题 @feiyugao
 */

export default {
  components: {
    SearchList,
    TreeList,
    TreeCheckboxList,
    BigTreeList,
    SelectedList,
  },
  props: {
    // 是否使用common里面的大容量组织架构树
    useBigTree: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default() {
        return this.$t('员工姓名/账号名/账号');
      },
    },

    show: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Array,
      default() {
        return [];
      },
    },
    single: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default() {
        return this.$t('选择员工');
      },
    },
    titleSelected: {
      type: String,
      default() {
        return this.$t('已选员工');
      },
    },
    subtitle: {
      type: String,
      default() {
        return this.$t('选择员工');
      },
    },

    // 是否可以选中部门
    departCanSelect: {
      type: Boolean,
      default: false,
    },

    // 非子节点是否可选
    folderCanSelect: {
      type: Boolean,
      default: true,
    },

    // 之前已经选中了的 跟selected同样不能选中，区别是显示样式不一样，并且不在右侧列表展示不可反选
    hisSelected: {
      type: Array,
      default() {
        return [];
      },
    },

    withCheckbox: {
      type: Boolean,
      default: false,
    },

    showResult: {
      type: Boolean,
      default: true,
    },

    showSearch: {
      type: Boolean,
      default: true,
    },

    custFetchTree: {
      type: Function,
      default: null,
    },

    custFetchSearch: {
      type: Function,
      default: null,
    },

    custSearchList: {
      type: Function,
      default: null,
    },

    maps: {
      type: Object,
      default: () => ({
        value: 'id',
        hasChildren: 'isFolder',
      }),
    },
  },
  data() {
    return {
      currentSelected: [],
      keywords: '',
      searching: false,
    };
  },
  computed: {
    titleSelectedAndNum() {
      if (this.currentSelected && this.currentSelected.length > 0) {
        return `${this.titleSelected}(${this.currentSelected.length})`;
      }
      return this.titleSelected;
    },
  },

  watch: {
    selected(nextValue) {
      this.currentSelected = [...nextValue];
    },

    currentSelected() {
      this.emitChange();
    },
  },
  created() {
    this.currentSelected = [...this.selected];
  },
  methods: {
    selectedChange(selected) {
      this.currentSelected = [...selected];
    },
    search() {
      this.searching = !!this.keywords;
      if (this.searching) {
        this.$refs.search.fetch();
      }
    },

    emitChange() {
      this.$emit('change', this.currentSelected);
    },

    getTree() {
      if (this.useBigTree) {
        return this.$refs.bigTree.getTree();
      }
      return this.$refs.checkTree.getTree();
    },
  },
};
</script>

<style lang="less">
@import './style.less';
</style>
